import React from "react";
import CommunityUpdate from "../../../components/CommunityUpdate";

const CommunityBunriUpdate = () => {
  return <CommunityUpdate posttype="bunri" />;
};

export default CommunityBunriUpdate;
